import {Injectable}    from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import {Empresa} from './empresa';

import myGlobals = require('../config');

@Injectable()
export class EmpresaService {

    private empresaUrl = myGlobals.default.BASE_URL + '/empresa/';  // URL to web api

    constructor(private http: Http) {
    }

    //Obtener todas las empresas
    getEmpresas() {
        return this.http.get(this.empresaUrl)
            .map((response) => response.json());
    }

    //Obtener una empresa
    getEmpresa(_id: string): Observable<Empresa> {
        return this.http.get(this.empresaUrl + _id)
            .map((response) => response.json());
    }

    save(empresa: Empresa, logo): Observable<Empresa> {
        if (empresa._id) {
            return this.put(empresa,logo);
        }
        //Seteo estado activo
        empresa.estado = true;
        return this.post(empresa, logo);
    }

    //Desactivar empresa
    delete(empresa: Empresa) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        let url = `${this.empresaUrl}/${empresa._id}`;

        return this.http
            .delete(url, {headers: headers})
            .map((response) => response.json());
    }

    // Agregar nueva empresa
    private post(empresa: Empresa, logo): Observable<Empresa> {
        var formData = new FormData();
        formData.append("logo", logo);
        formData.append("empresa", JSON.stringify(empresa));
        let headers = new Headers();
        headers.append('enctype', "multipart/form-data");
        return this.http
            .post(this.empresaUrl, formData, {headers: headers})
            .map((response) => response.json());
    }

    // Actualizar empresa
    private put(empresa: Empresa, logo) {
        empresa.logo = null;
        var formData = new FormData();
        formData.append("logo", logo);
        formData.append("empresa", JSON.stringify(empresa));
        let headers = new Headers();
        headers.append('enctype', "multipart/form-data");
        ;

        let url = `${this.empresaUrl}/${empresa._id}`;

        return this.http
            .put(url, formData, {headers: headers})
            .map((response) => response.json());
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/empresa/empresa.service.ts